// Teacher "Send store charge" copy.
export const storeCharge = {
  entryLabel: "Send Store Charge",
  // Per-row action name — the tooltip stays entryLabel.
  entryLabelFor: "Send Store Charge to {{- name}}",
  cancel: "Cancel",
  stockUnlimited: "Unlimited",
  confirmClose: {
    title: "Discard this store charge?",
    body: "The items you picked will be cleared and nobody will be charged.",
    discard: "Discard",
    keep: "Keep editing",
  },
  emptySelection:
    "Pick at least one student from the class list to send a store charge.",

  select: {
    title: "Send store charge",
    subtitle: "Pick store items to charge the selected students.",
    available_one: "{{count}} available",
    available_other: "{{count}} available",
    storeItems: "Store items",
    capPerItem: "Max 500 per item.",
    capLines: "You can charge up to 20 items at once.",
    summaryItems_one: "{{count}} item",
    summaryItems_other: "{{count}} items",
    summaryStudents_one: "charging {{count}} student",
    summaryStudents_other: "charging {{count}} students",
    summaryEach: "<coin/>{{amount}} each",
    reviewAction: "Review charge",
    loading: "Loading items…",
    errorTitle: "Couldn't load store items.",
    tryAgain: "Try again",
    emptyNoMatch: "No items match \"{{- query}}\"",
    emptyNoItems: "This class store has no items yet.",
  },

  tile: {
    stockLeft_one: "{{count}} left",
    stockLeft_other: "{{count}} left",
    quantity: "x{{count}}",
    addA11y: "Add one {{- item}}",
    increaseA11y: "Increase {{- item}} quantity",
    decreaseA11y: "Decrease {{- item}} quantity",
    removeA11y: "Remove {{- item}}",
    inCartA11y: "In cart: {{count}}",
  },

  review: {
    title: "Review store charge",
    subtitle: "Confirm the items, totals and balances before charging.",
    chargingHeading_one: "Charging {{count}} student",
    chargingHeading_other: "Charging {{count}} students",
    excluded: "Excluded: {{- names}}",
    studentsOverflow_one: "+{{count}} more",
    studentsOverflow_other: "+{{count}} more",
    excludedCount_one: "{{count}} excluded",
    excludedCount_other: "{{count}} excluded",
    wholeClassFallback_one: "Whole class ({{count}} student)",
    wholeClassFallback_other: "Whole class ({{count}} students)",
    wholeClassFallbackNote:
      "Students who can't afford the cart won't be charged.",
    rosterError: "Couldn't load the class list.",
    tryAgain: "Try again",
    itemsHeading: "Items",
    colItem: "Item",
    colQty: "Qty",
    colUnitPrice: "Unit price",
    colLineTotal: "Line total",
    colStockRemaining: "Stock remaining",
    totalPerStudent: "Total per student",
    totalAcross_one: "Total across {{count}} student",
    totalAcross_other: "Total across {{count}} students",
    backAction: "Back to items",
    chargeAction_one: "Charge {{count}} student",
    chargeAction_other: "Charge {{count}} students",
  },

  stock: {
    notEnough: "Not enough stock",
    shortDetail: "{{available}} left, needs {{required}}",
    error_one:
      "Not enough stock for {{count}} item. Go back and lower the quantity or remove the item.",
    error_other:
      "Not enough stock for {{count}} items. Go back and lower the quantities or remove the items.",
    fallbackWarning: "May not be enough stock if every student is charged.",
  },

  conflict: {
    banner: "Stock changed before the charge went through. Nobody was charged.",
  },

  balance: {
    heading: "Balance check",
    colStudent: "Student",
    colBalance: "Balance",
    colCharge: "Charge",
    colBalanceAfter: "Balance after",
    wontBeCharged: "Won't be charged",
    notChargedA11y: "Not charged",
    skippedMessage_one:
      "{{count}} student won't be charged. Their balance is too low for the whole cart.",
    skippedMessage_other:
      "{{count}} students won't be charged. Their balance is too low for the whole cart.",
    noneCanAfford:
      "None of the selected students can afford this cart. Go back and remove items or lower quantities.",
  },

  done: {
    dialogTitle: "Charge complete",
    title: "Store charge sent!",
    summary_one:
      "Charged <b>{{count}}</b> student <b>{{perStudent}}</b> each (<b>{{total}}</b> total).",
    summary_other:
      "Charged <b>{{count}}</b> students <b>{{perStudent}}</b> each (<b>{{total}}</b> total).",
    inventoryUpdated: "Store inventory has been updated.",
    skipped_one:
      "<b>{{count}}</b> student wasn't charged - balance too low for the whole cart.",
    skipped_other:
      "<b>{{count}}</b> students weren't charged - balance too low for the whole cart.",
    noneTitle: "No students were charged",
    noneBody:
      "Every selected student's balance was too low for the whole cart. Stock wasn't changed.",
    close: "Done",
  },
}
